<div class="confirmation-window">
    <div class="confirmation-window__content">
        <div agModalTitle>{{ config.title }}</div>
        <div agModalSubtitle>{{ config.text }}</div>
        <div agModalActions>
            <button agButton="filled" (click)="proceed()">{{ config.confirmLabel }}</button>
            <button agButton color="base" size="small" (click)="reject()">{{ config.rejectLabel }}</button>
        </div>
    </div>
</div>
